const timeValue = (value) => {
  if (typeof value === "number") return value;
  if (typeof value !== "string" || !value.trim()) return NaN;
  return /^\d+$/.test(value) ? Number(value) : Date.parse(value);
};

// /client/channel supplies real guide entries in epgs. Its currentProgram can
// be a synthetic fallback, so an explicitly empty guide must stay empty here.
// Limit channels first: an EPG gap must not pull in channel 21.
export const nowOnAir = (channels, now) =>
  channels.slice(0, 20).flatMap((channel) => {
    const candidates = Array.isArray(channel.epgs)
      ? channel.epgs
      : [channel.currentProgram];
    const program = candidates.find((item) => {
      const start = timeValue(item?.startTime ?? item?.begintime);
      const end = timeValue(item?.endTime ?? item?.endtime);
      return (
        item?.id &&
        item.id !== channel.id &&
        item.id !== "00000000-0000-0000-0000-000000000000" &&
        item.title &&
        Number.isFinite(start) &&
        Number.isFinite(end) &&
        start <= now &&
        now < end
      );
    });
    return program ? [{ channel, program }] : [];
  });
